<template>
    <div class="data-table-model-list-content">
        <div class="opera-btn">
            <div v-if="this.selectType===2" class="condtion-btn">
                <el-radio-group  v-model="quickEntryMode" @change="changeModelType">
                    <el-radio  :label="0">表单</el-radio>
                    <el-radio  :label="1">审批流模板</el-radio>
                    <el-radio  :label="2">业务流模板</el-radio>
                </el-radio-group>
            </div>
            <div class="condtion-btn" v-if="this.selectType===1">
                <el-input style="width:250px; " maxlength="100" v-model.trim="modelName" placeholder="请输入模型名称">
                    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                </el-input>
            </div>
            <el-button type="primary" @click="saveDataTableConfig">保存</el-button>
            <el-button  @click="cancelDataTableConfig">取消</el-button>
        </div>
        <div class="search-box">
        </div>
        <div class="content-box">
            <el-table v-if="quickEntryMode===0" stripe :data="modelList" style="width: 100%" height="500" :border="true" v-loading="loading" :class="'modelListTable'" @selection-change="handleSelectionChange" @current-change="clickChange">
                <el-table-column label="选择" width="55" v-if="selectType===1">
                     <template slot-scope="scope">
                        <el-radio v-model="tableRadio" :label="scope.row"><i></i></el-radio>
                     </template>
                </el-table-column>

                <el-table-column
                  v-if="selectType===2"
                  type="selection"
                  width="55">
                </el-table-column>

                <el-table-column prop="appName" label="所属应用" :show-overflow-tooltip="true" min-width="100"></el-table-column>
                <el-table-column prop="functionName" label="功能模块" :show-overflow-tooltip="true" min-width="100"></el-table-column>
                <el-table-column prop="modelName" label="模型名称" :show-overflow-tooltip="true" min-width="100"></el-table-column>
                <el-table-column prop="state" label="使用状态" min-width="70" :sortable="true">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state === 1" type="success">已发布</el-tag>
                        <el-tag v-if="scope.row.state === 0" type="info">未发布</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="authName" label="已授权人员" min-width="60" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="created" label="创建时间" :show-overflow-tooltip="true" :sortable="true" min-width="80"></el-table-column>
            </el-table>
            <div v-if="quickEntryMode===1">
                <el-table :data="approvalTemplateList" :border="true" v-loading="loading" height="410" style="margin-top:-10px" @selection-change="handleSelectionChange">
                  <el-table-column
                    v-if="isSelect"
                    type="selection"
                    width="55">
                  </el-table-column>
                    <el-table-column
                      label="模板名称"
                      :show-overflow-tooltip="true"
                      align="center"
                      width="100">
                      <template slot-scope="scope">
                          <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.templateName }}</span>
                      </template>
                    </el-table-column>
                     <el-table-column
                        v-if="!isDesign"
                        prop="busiTypeName"
                        width="100"
                        label="审批类型"
                        align="center"
                      >
                    </el-table-column>
                     <el-table-column
                      label="发布状态"
                      width="90">
                      <template slot-scope="scope">
                         <el-tag type="success" v-if="scope.row.templateState==1">已发布</el-tag>
                         <el-tag type="info"  v-else>未发布</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="审批流顺序"
                      align="center"
                      >
                      <template slot-scope="scope">
                          <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                              <el-step v-for="(item, index) in scope.row.users" :key="index" :title="item.trueName"></el-step>
                          </el-steps>
                          <el-steps v-if="scope.row.approvalMethod == 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                              <el-step v-for="(item, index) in scope.row.approvalList"  :key="index" align-center >
                                  <el-breadcrumb v-if="item && item.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                      <el-breadcrumb-item  v-for="(user, i) in item" :key="i">{{user.trueName}}</el-breadcrumb-item>
                                  </el-breadcrumb>
                              </el-step>
                          </el-steps>
                      </template>
                    </el-table-column>
                  </el-table>
                   <el-row type="flex" justify="end">
                      <el-pagination
                          background
                          layout="total, prev, pager, next"
                          :total="page.totalPageNum"
                          :current-page="page.currentPage"
                          :page-size="page.pageSize"
                          @current-change="queryFormData"
                      />
                  </el-row>
            </div>
            <div v-if="quickEntryMode===2">
                  <el-table :data="processList" :border="true" v-loading="loading" height="410" style="margin-top:-10px" @selection-change="handleSelectionChange">
                    <el-table-column
                      v-if="isSelect"
                      type="selection"
                      width="55">
                    </el-table-column>
                      <el-table-column
                        label="模板名称"
                        :show-overflow-tooltip="true"
                        align="center"
                        width="500">
                        <template slot-scope="scope">
                            <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.templateName }}</span>
                        </template>
                      </el-table-column>
                       <el-table-column
                          prop="version"
                          width="100"
                          label="版本"
                          align="center"
                        >
                      </el-table-column>
                      <el-table-column
                          label="描述"
                          prop="description"
                          align="center"
                        >
                      </el-table-column>
                    </el-table>
            </div>
        </div>
        <div v-if="quickEntryMode===0"  class="page-box">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :total="page.totalPageNum"
                :current-page="page.currentPage"
                :page-size="page.pageSize"
                :page-sizes="[10, 20, 30, 50, 100]"
                @current-change="queryFormData"
                @size-change="queryFormDataByPageSize"
            />
        </div>
    </div>
</template>

<script>
    import {getModelListByType, getApprovalTemplateList, getProcessTemplateList} from '@/data-model';
    export default{
        props: {
            dataType: {
                type: Number,
                default: 1
            },
            selectType: {
                type: Number,
                default: 1
            },
            defaultQuickEntryMode: {
                type: Number,
                default: 0
            }

        },
        data () {
            return {
                searchParams: {
                    busiType: '',
                    busiTypeName: '',
                    templateName: '',
                    templateState: 1,
                    formId: ''
                },
                modelList: [],
                loading: false,
                page: {
                    totalPageNum: 0,
                    currentPage: 1,
                    pageSize: 10
                },
                tableRadio: {},
                chooseData: [],
                isFormListView: false,
                isProcessListView: false,
                modelName: '',
                quickEntryMode: this.defaultQuickEntryMode ? this.defaultQuickEntryMode : 0, // 0表单 1审批流 2业务流
                approvalTemplateList: [],
                isSelect: true,
                isDesign: false,
                processSearchParams: {
                    key: '',
                    serviceName: '',
                    definitionName: '',
                    state: 1 // 版本范围 ：默认 最新版
                },
                processList: []
            };
        },
        created () {
            this.isFormListView = true;
            this.initModelList();
        },
        methods: {
            async initModelList () {
                this.loading = true;
                let param = {modelType: this.dataType, currentPage: this.page.currentPage, pageSize: this.page.pageSize, modelName: this.modelName};
                let res = await getModelListByType(param);
                if (res.state === 'success') {
                    this.modelList = res.data;
                    this.page.totalPageNum = res.count;
                }
                this.loading = false;
            },
            queryFormData (currentPage) {
                this.page.currentPage = currentPage;
                this.initModelList();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this.initModelList();
            },
            clickChange (item) {
                this.tableRadio = item;
            },
            async getApproveTemplateList () {
                this.loading = true;
                let formData = await getApprovalTemplateList(Object.assign({}, {
                    currentPage: 0,
                    pageSize: '1000'
                }, this.searchParams));
                this.approvalTemplateList = formData.data;
                this.page = {
                    currentPage: formData.currentPage,
                    pageSize: formData.pageSize,
                    totalPageNum: formData.totalPageNum
                };
                this.loading = false;
            },
            async getBusinessTemplateList () {
                this.loading = true;
                let { data } = await getProcessTemplateList(this.processSearchParams);
                this.processList = data;
                this.loading = false;
            },
            saveDataTableConfig () {
                if (this.quickEntryMode === 0) {
                    if (this.selectType === 1) { // 单选
                        this.$emit('configDataTableModelList', this.tableRadio);
                    } else if (this.selectType === 2) { // 多选
                        this.$emit('configDataMultipleModelList', this.chooseData);
                    }
                } else if (this.quickEntryMode === 1) { // 审批流模板
                    this.$emit('configDataProcessMode', this.quickEntryMode, this.chooseData);
                } else if (this.quickEntryMode === 2) { // 业务流模板
                    this.$emit('configDataProcessMode', this.quickEntryMode, this.chooseData);
                }
            },
            cancelDataTableConfig () {
                this.$emit('cancelDataTableModelList');
            },
            handleSelectionChange (val) {
                this.chooseData = val;
            },
            handleSearch () {
                this.initModelList();
            },
            changeModelType (obj) {
                if (obj === 0) {
                    this.initModelList();
                } else if (obj === 1) {
                    this.getApproveTemplateList();
                } else if (obj === 2) {
                    this.getBusinessTemplateList();
                }
            }
        }
    };
</script>

<style lang="less">
    .showDashBoardModel{
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding-top: 0px;
            .data-table-model-list-content{
                .opera-btn{
                    height: 40px;
                    line-height: 40px;
                    text-align: right;
                    margin-bottom: 10px;
                    margin-top: 10px;
                    .condtion-btn{
                      float: left;
                    }
                }
                .page-box{
                    margin-top: 10px;
                }
                .quickEntranceNav-item {
                      height: 180px;
                      width: 280px;
                      // min-width: 15%;
                      // margin: 5px;
                          margin: 15px 10px 10px 10px;
                      border: 1px solid #e8edf1;

                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      .el-card__body {
                          flex: 1;
                          display: flex;
                          flex-direction: column;
                      }

                  }
                .quickEntranceNav-item:hover {
                    border: 1px solid #6db2bb;
                }
                .quickEntranceNav-bottom {
                    margin-top: auto;
                    font-size: 12px;
                    background-color: #e8edf1;
                    padding: 5px;

                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                }
                .quickEntranceNav-app-title{
                    width: 100%;
                    color: #4caf50;
                }
                .quickEntranceNav-button {
                 // color:#4caf50;
                    color:#909399;
                    font-size: 30px;
                    text-align: center;
                    margin-top: 20%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DataTableModelList.vue